import { SITE_VARIABLES } from '../../styles/variables';
import { ToolTipType } from './toolTip.contants';
import { Variables } from './toolTip';

const tooltipFontSize = '10px';
const tooltipFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;
const tooltipBackgroundColor = SITE_VARIABLES.COLORS.BLACK;
const tooltipColor = SITE_VARIABLES.COLORS.WHITE;

interface StylesObject {
  tooltipStyle: { [key: string]: any };
  tooltipContentStyle: { [key: string]: any };
}
type HoverObject = { hover: { [key: string]: any } } & any;

type TooltipContent = {
  top: HoverObject;
  topLeft: HoverObject;
  topRight: HoverObject;
  bottom: HoverObject;
  hover: { [key: string]: any };
} & any;

interface ToolTipStyles {
  position: string;
  display: string;
  tooltipContent: TooltipContent;
}

const toolTip = (variables: Variables = { marginLeft: '0px', marginRight: '0px' }): ToolTipStyles => {
  const { marginLeft, marginRight, marginBottom } = variables;
  return ({
    position: 'relative',
    display: 'contents',
    tooltipContent: {
      color: tooltipColor,
      backgroundColor: tooltipBackgroundColor,
      width: 'max-content',
      fontFamily: tooltipFontFamily,
      fontSize: tooltipFontSize,
      padding: '4px 8px',
      position: 'absolute',
      opacity: '0',
      background: tooltipBackgroundColor,
      borderRadius: SITE_VARIABLES.BORDER_RADIUS.EXTRA_TINY,
      pointerEvents: 'none',
      zIndex: '2',
      maxWidth: '388px',
      overflowWrap: 'break-word',
      wordWrap: 'break-word',
      hyphens: 'auto',
      marginRight,
      marginLeft,
      marginBottom: marginBottom || '8px',
      top: {
        bottom: '100%',
        left: '50%',
        transform: 'translate(-50%, 0)',
        hover: {
          opacity: '1',
          transform: 'translate(-50%, 0)',
        },
      },
      topLeft: {
        bottom: '100%',
        right: '0',
        transform: 'translate(-50%, 0)',
        hover: {
          opacity: '1',
          transform: 'translate(0, 0)',
        },
      },
      topRight: {
        bottom: '100%',
        left: '0',
        transform: 'translate(-50%, 0)',
        hover: {
          opacity: '1',
          transform: 'translate(0, 0)',
        },
      },
      bottom: {
        top: '100%',
        left: '50%',
        transform: 'translate(-50%, 0)',
        hover: {
          opacity: '1',
          transform: 'translate(-50%, 0)',
        },
      },
      bottomRight: {
        top: '100%',
        left: '0',
        hover: {
          opacity: '1',
          transform: 'translate(0, 0))',
        },
      },
      hover: {
        opacity: '1',
      },
    },
  });
};

export const getTooltipStyleObject = (hovered: boolean, position: ToolTipType, variables: Variables): StylesObject => {
  const tooltip = toolTip(variables);
  return ({
    tooltipStyle: [
      tooltip,
    ],
    tooltipContentStyle: [
      tooltip.tooltipContent,
      hovered && tooltip.tooltipContent.hover,
      tooltip.tooltipContent[position],
      hovered && tooltip.tooltipContent[position].hover,
    ],
  });
};
